class Blog {
	constructor(request) {
		this.request = request
		this.endpoint = 'blog'
	}

    GetBlogs(type) {
        return this.request.requestData(
            `https://cdn.ngnw.ph/lists/${this.endpoint}/${type}.json`
        )
    }
}

export default Blog;